import DataTable from 'react-data-table-component';
import React from 'react'
import Actionall from './actionall';
import Statusall from '../componentallstatus/statusall';
import { FaFileSignature, FaCheckCircle, FaExclamationTriangle } from "react-icons/fa";
import Flowuserapprove from '../componentallstatus/flowuserapprove';

const columns = [
    {
        name: 'create',
        sortable: true,
        width: '110px',
        selector: row => row.createdate,
    },
    {
        name: 'TDS code',
        sortable: true,
        width: '120px',
        selector: row => row.tdscode,
    },
    {
        name: 'V',
        sortable: true,
        width: '60px',
        selector: row => row.revision,
    },
    {
        name: 'customer / product',
        grow: 2,
        selector: row => <div>
            <div>: {row.fname}</div>
            <div>: {row.customername}</div>
            <div>: {row.productname}</div>
             <div style={{color:'blue'}}>cansize : {row.cansize}</div>
        </div>,
    },
    // {
    //     name: 'cansize',
    //     width: '90px',
    //     selector: row => row.cansize,
    // },
    {
        name: 'status all',
        width: '150px',
        selector: row => row.statusflow === '0000'
            ? <span style={{
                display: 'inline-flex', alignItems: 'center', gap: 5,
                backgroundColor: '#fee2e2', color: '#b91c1c',
                border: '1px solid #fca5a5', borderRadius: 20,
                padding: '3px 10px', fontWeight: 700, fontSize: 11,
                whiteSpace: 'nowrap',
            }}>
                <FaExclamationTriangle size={10} /> ยกเลิกเอกสาร
            </span>
            : <Statusall id={row.journalId} statusNow={row.stateflow} stateSuccesfull={row.stateSuccesfull} />,
    },
    {
        name: 'รออนุมัติ',
     width: '200px',
        selector: row => row.flowSuccesfull != "1" ? <Flowuserapprove
            id={row.journalId}
            stateflow={row.stateflow}
            departments={row.departments}
            accountapprove={row.accountapprove}
        /> : "",
    },
    {
        name: 'confirm job',
        width: '110px',
        selector: row => (
            <div>
                {Number(row.statusConfirm) === 1 && (
                    <span style={{
                        display: 'inline-flex', alignItems: 'center', gap: 4,
                        backgroundColor: '#198754', color: '#fff',
                        borderRadius: 12, padding: '3px 10px',
                        fontSize: 11, fontWeight: 600, whiteSpace: 'nowrap'
                    }}>
                        <FaCheckCircle size={10} /> Approve
                    </span>
                )}
            </div>
        ),
    },
    {
        name: 'Action',
        width: '150px',
        cell: row => <Actionall id={row.journalId} journalcode={row.tdscode}
            stateflow={row.stateflow}
            stateSuccesfull={row.stateSuccesfull}
            revision={row.revision}
        />,
    },
];

const customStyles = {
    headRow: {
        style: {
            border: 'none',
            backgroundColor: '#28B463'
        },
    },
    headCells: {
        style: {
            color: '#ffff',
            fontSize: '14px',
        },
    },
    rows: {
        highlightOnHoverStyle: {
            backgroundColor: 'rgb(230, 244, 244)',
            borderBottomColor: '#FFFFFF',
            borderRadius: '25px',
            outline: '1px solid #FFFFFF',
        },
    },
    pagination: {
        style: {
            border: 'none',
        },
    },
};



const Jornallistbyuser = (datatable) => {
    var dataresult = datatable.datatable;
    // console.log(dataresult)

    return (

        <DataTable
            columns={columns}
            data={dataresult}
            // selectableRows
            pagination
            customStyles={customStyles}
             paginationPerPage={20}
            highlightOnHover
        />
    )
}

export default Jornallistbyuser